// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import clockPlusIcon from "@/assets/icons/clock-plus.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type ClockPlusIconProps = Omit<IconProps, "name">;

export function ClockPlusIcon(props: ClockPlusIconProps): React.ReactNode {
  return <Icon name={clockPlusIcon} {...props} />;
}
